import { Grid } from "@mui/material";
import React from "react";
import io from "socket.io-client";
import MessageBox from "./MessageBox";
import AllUsers from "./Users";
import { socketUrl } from "../../services";

const socket = io.connect(socketUrl);

function Chat() {
  return (
    <Grid container spacing={1}>
      <Grid item xs={12} md={3.5}>
        <AllUsers socket={socket} />
      </Grid>
      <Grid item xs={12} md={8.5} sx={{ display: { xs: "none", md: "block" } }}>
        <MessageBox socket={socket} />
      </Grid>
    </Grid>
  );
}

export default Chat;
